import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase"; // Firebase auth
import Lottie from "lottie-react"; 
import animationData from "../Assets/login.json"; // Lottie animation file
import "./Signin.css";
import logo from "../Assets/logo.png";

const Login = ({setIsLoggedIn}) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, formData.email, formData.password);
      const user = userCredential.user;

      // Store token and username
      localStorage.setItem("token", user.accessToken);
      localStorage.setItem("username", user.displayName || "User");

      // Redirect after animation
      setTimeout(() => {
        setIsLoggedIn(true)
        navigate("/");
      }, 2000);
    } catch (error) {
      alert(error.message);
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      {isLoading && (
        <div className="overlay">
          <Lottie animationData={animationData} loop={true} className="lottie-animation" />
        </div>
      )}
      
      <div className="form-container">
        <h1>Login</h1>
        <p className="subtitle">Welcome back! Please log in to continue.</p>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input type="email" name="email" placeholder="Email Address" required onChange={handleChange} />
          </div>

          <div className="input-group">
            <input type="password" name="password" placeholder="Password" required onChange={handleChange} />
          </div>

          <button type="submit" className="submit-button" disabled={isLoading}>Login</button>
        </form>

        <p className="terms">
          Don't have an account?{" "}
          <a href="#" onClick={() => navigate("/signin")}>Sign up</a>
        </p>
      </div>

      <div className="illustration">
        <img src={logo} alt="Decorative Illustration" className="illustration-image" />
      </div>
    </div>
  );
};

export default Login;
